import React, { Fragment, useState } from 'react'
import { Dialog, ButtonBase, Card, CardMedia, makeStyles } from '@material-ui/core'
import { pictureUrl } from './common/pictureUrl'

const useStyles = makeStyles({
  img: {
    display: 'grid',
    width: '100%',
    height: 'auto'
  }
})

export default function ProjectPictures({ id, projectPics, isPortfolio }) {
  const [pic1, setPic1] = isPortfolio
    ? useState({
      record_type: '',
      record_id: 0,
      id: 0,
      name: 'file'
    })
    : useState({
      record_type: '',
      record_id: 0,
      id: 0,
      name: 'file',
      created_at: 0
    })

  const [dialogOpen, setDialogOpen] = React.useState(false)

  const handleClickOpen = (pic) => {
    setDialogOpen(true)
    setPic1(pic)
  }
  const handleClose = () => {
    setDialogOpen(false)
  }

  const pic = isPortfolio
    ? {
      record_type: 'Project::Picture',
      record_id: id,
      id,
      name: 'file'
    }
    : {
      record_type: 'Project::Picture',
      record_id: id,
      id,
      name: 'file',
      created_at: projectPics[id].file_blob.created_at
    }

  const classes = useStyles()

  return (
    <Fragment>
      <Card elevation={1}>
        <ButtonBase onClick={() => handleClickOpen(pic)}>
          <CardMedia>
            <img src={pictureUrl(pic, 600, 600)} className={classes.img} />
          </CardMedia>
        </ButtonBase>
      </Card>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={dialogOpen} maxWidth="md">
        <img style={{ width: 'auto', height: 'auto' }} src={pictureUrl(pic1, 800, 800)} />
      </Dialog>
    </Fragment>
  )
}
